import { ONBOARDING_MODE } from "../features/onboarding/onboardingDraft";

const MAIN_TAB_IDS = ["home", "reels", "profile"];

export function isOnboardingRoute(pathname) {
  return pathname.startsWith("/onboarding");
}

export function isEditOnboardingRoute(pathname, state) {
  return isOnboardingRoute(pathname) && state?.mode === ONBOARDING_MODE.EDIT;
}

export function getMainTabId(pathname) {
  if (pathname === "/" || pathname === "/location") return "home";
  if (pathname.startsWith("/reels")) return "reels";
  if (pathname.startsWith("/profile-details") || pathname.startsWith("/user-profile")) {
    return "profile";
  }
  return null;
}

export function isMainTabRoute(pathname) {
  return MAIN_TAB_IDS.includes(getMainTabId(pathname));
}
